
// export const baserUrl = 'http:///127.0.0.1:8084';
export const baserUrl = 'https://hcv-portal-admin-api-bucfdvcfeba9gfbq.canadacentral-01.azurewebsites.net';


export const baseUrl = baserUrl + '/api';

export const TEXT_HEADERS = (token: string | null) => {
    return {
        "Content-Type": "text/plain",
        "Authorization": `Bearer ${token}`
    };
};
export const JSON_HEADERS = (token: string | null) => {
    return {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
    };
};
export const AUTH_HEADERS = (token: string | null) => {
    return {
        "Authorization": `Bearer ${token}`
    };
};

export interface Content {
    id: number;
    type: string;
    name: string;
    total: number;
    createdAt: string;
    updatedAt: string;
    ready: boolean;
    parentGroupId?: number;
}

export interface GroupInfo {
    id: number;
    name: string;
}

export interface Group {
    name: string;
    path: GroupInfo[];
    contentList: Content[];
}

export interface Portal {
    id: number;
    name: string;
}

export interface Tag {
    id: number;
    name: string;
}

export interface Package {
    id: number;
    name: string;
    description: string;
    images: string;
    ready: boolean;
    files: PackageFile[];
    levels: string[];
    categories: string[];
    type: string;
    price: number;
}

export interface PackageFile {
    id: number;
    name: string;
    duration: number;
}

export interface Tag {
    id: number;
    name: string;
    predefined: boolean;
}

export interface ShortPortal {
    id: number;
    name: string;
    type: string;
    createdAt: string;
    expiresAt: string;
    federationName: string;
}

export interface FetchRequest {
    nameFilter?: string;
    orderBy: string;
    orderDirection: string;
    page: number;
    size?: number;
}

export interface UpdatePortalRequest {
    name: string;
    type: string;
    createdAt: string;
    expiresAt?: string;

    packageColor: string;
    backgroundColor: string;

    disabledAddPlayer: boolean;
    userLimit: number;
    maxUserLimit: number;

    federationId: number;
    inviteTemplateId: number;
    ownedInviteTemplateId: number;
}

export interface UpdateFederationRequest {
    name: string;
}

export interface FetchPortalsResponse {
    total: number;
    portals: ShortPortal[];
}

export interface Sponsor {
    name: string;
    location: string;
    updated: string;
}

export interface PortalDetails {
    id: number;
    name: string;
    type: string;
    createdAt: string;
    expiresAt?: string;

    packageColor: string;
    backgroundColor: string;

    disabledAddPlayer: boolean;
    userLimit: number;
    maxUserLimit: number;

    federationId: number;
    inviteTemplateId: number;
    ownedInviteTemplateId: number;

    sponsorImages: Sponsor[];
}

export interface Federation {
    id: number;
    name: string;
    createdAt: string;
    portals: string[];
}

export interface MailTemplate {
    id: number;
    name: string;
    subject: string;
    draft: string;
    placeholders: string[];
}

export interface UpdateMailTemplate {
    name: string;
    subject: string;
    draft: string;
    draftHtml: string;
}

export interface User {
    id: number;
    email: string;
    accountType: string;
    license: string;
    role: string;

    name: string;
    biography: string;
    inviteSent: boolean;
    defaultPassword: string;
    owned: boolean;

    registered: string;
    expires: string;
    permission: string;
    promoCode: string;
}

export interface FullUser {
    id: number;
    email: string;
    startingPassword: string;
    emailConfirmed: boolean;
    newsletterApproved: boolean;
    accountType: string;
    permission: string;
    accountNumber: string;
    promoCode: string;
    expires?: string;
    trial: boolean;
    trialExpires?: string;
    lastLogin: string;

    devices: string[];
    portals: string[];
    packages: string[];
}

export interface FetchUsersRequest {
    emailFilter?: string;
    orderBy: string;
    orderDirection: string;
    page: number;
}

export interface FetchUsersResponse {
    total: number;
    users: User[];
}

export interface OrgInfo {
    remainingSlotsCount: number;
    maxRemainingSlotsCount: number;
}

export interface FetchFederationsResponse {
    total: number;
    items: Federation[];
}

export interface FetchDevicesResponse {
    total: number;
    devices: Device[];
}

export interface Device {
    id: string;
    operatingSystem: string;
    registered: string;
    status: boolean;
    owner: string;
    active: boolean;
}

export interface FetchMailsResponse {
    total: number;
    items: MailTemplate[];
}

export interface Referrer {
    id: number;
    email: string;
    confirmed: number;
    total: number;
}

export interface ReferrerResponse {
    email: string;
    referrals: Referral[];
}

export interface Referral {
    email: string;
    confirmed: boolean;
}



